export const APPROVAL_FLOW_KEYS = {
  LEADER_RRHH: "leader_rrhh",
  AUTOMATIC: "automatic",
} as const;

export const APPROVAL_FLOW_VALUES = {
  [APPROVAL_FLOW_KEYS.LEADER_RRHH]: "Líder inmediato → RRHH",
  [APPROVAL_FLOW_KEYS.AUTOMATIC]: "Automático",
} as const;
